var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoomGuests(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 0.0012C6.04032 -0.0121829 5.48361 0.0864879 4.96263 0.291408C4.44164 0.496328 3.9669 0.803359 3.56633 1.19444C3.16575 1.58552 2.84744 2.05276 2.63011 2.56866C2.41278 3.08456 2.30082 3.63871 2.30082 4.19852C2.30082 4.75832 2.41278 5.31248 2.63011 5.82838C2.84744 6.34428 3.16575 6.81152 3.56633 7.2026C3.9669 7.59368 4.44164 7.90071 4.96263 8.10563C5.48361 8.31055 6.04032 8.40922 6.6 8.39584C7.15968 8.40922 7.71639 8.31055 8.23737 8.10563C8.75836 7.90071 9.2331 7.59368 9.63367 7.2026C10.0342 6.81152 10.3526 6.34428 10.5699 5.82838C10.7872 5.31248 10.8992 4.75832 10.8992 4.19852C10.8992 3.63871 10.7872 3.08456 10.5699 2.56866C10.3526 2.05276 10.0342 1.58552 9.63367 1.19444C9.2331 0.803359 8.75836 0.496328 8.23737 0.291408C7.71639 0.0864879 7.15968 -0.0121829 6.6 0.0012ZM4.2 10.7933C3.08609 10.7933 2.0178 11.2357 1.23015 12.0233C0.442499 12.811 0 13.8792 0 14.993V17.9892H13.2V14.993C13.2 13.8792 12.7575 12.811 11.9698 12.0233C11.1822 11.2357 10.1139 10.7933 9 10.7933H4.2ZM15 12.0004H14.4V18H18V15.0002C18 14.2046 17.6839 13.4416 17.1213 12.879C16.5587 12.3164 15.7956 12.0004 15 12.0004Z",
    fill: "url(#paint0_linear_715_15333)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 4.80088C13.0044 4.80088 12.2413 5.11693 11.6787 5.6795C11.1161 6.24207 10.8 7.00508 10.8 7.80068C10.8 8.59628 11.1161 9.35929 11.6787 9.92186C12.2413 10.4844 13.0044 10.8005 13.8 10.8005C14.5956 10.8005 15.3587 10.4844 15.9213 9.92186C16.4839 9.35929 16.8 8.59628 16.8 7.80068C16.8 7.00508 16.4839 6.24207 15.9213 5.6795C15.3587 5.11693 14.5956 4.80088 13.8 4.80088Z",
    fill: "url(#paint1_linear_715_15333)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_15333",
    x1: 3.24,
    y1: 4.5381e-8,
    x2: 16.6488,
    y2: 18.7196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8264F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_715_15333",
    x1: 13.8,
    y1: 4.80088,
    x2: 13.8,
    y2: 10.8005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8264F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomGuests);
export default __webpack_public_path__ + "static/media/roomGuests.3ea8cedd3f9430323308acad2963da01.svg";
export { ForwardRef as ReactComponent };